import Button from '../../../components/Button';
import MailInFormsModal from './MailInFormsModal';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container } from 'react-bootstrap';
import useModal from '../../../hooks/useModal';

const MailInFormsDemo = () => {
  const [showModal, handleShow, handleClose] = useModal();

  return ( 
    <Container>
      <Container className="mt-10">
        <h4>Mail In Forms Modal</h4>
        <Button
          onMouseDown={handleShow}
          variant="primary"
          rightIcon={light('mailbox')}
        >
          Mail In
        </Button>
        <MailInFormsModal showModal={showModal} handleClose={handleClose} />
      </Container>
    </Container>
  );
};

export default MailInFormsDemo;
